module.exports = __webpack_public_path__ + "static/media/trophy.e1cf097a.svg";